import { render } from "./navLeft.vue?vue&type=template&id=56fe3ee4&ts=true"
import script from "./navLeft.vue?vue&type=script&lang=ts"
export * from "./navLeft.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\sunjibo\\upstream_space\\code\\shenzhou\\medical-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__